import styled from 'styled-components';

export const StyledCode = styled.code`
  background-color: ${(p) => p.theme.alias.shadow};
  display: inline-block;
  padding: ${(p) => p.theme.space[0]} 4px;
  font-size: 12px;
  vertical-align: top;
  text-decoration: inherit;
`;
